import React from 'react';
import './styles/map.css';
import './styles/index.css';
import App from './components/App';
import ReactDOM from 'react-dom/client';
import startMapping from "./plugins/mapListener";
import {start} from "./plugins/Socket";


const root = ReactDOM.createRoot(document.getElementById('root'));

startMapping();
start();


root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);



// WEBPACK FOOTER //
// ./src/index.js